"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONDITIONAL_SUBMIT_FLAG = void 0;
var CONDITIONAL_SUBMIT_FLAG = '@@ddf-common-wizard__conditional-submit-step';
exports.CONDITIONAL_SUBMIT_FLAG = CONDITIONAL_SUBMIT_FLAG;